var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pages_content table"},[_c('iframe',{staticStyle:{"height":"100%","width":"100%"},attrs:{"src":_vm.url,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }